import { Grid2 } from '@mui/material'
import React from 'react'
import { Outlet } from 'react-router-dom'

const AuthLayout = () => {
  return (
    <Grid2
      container
      spacing={1}
      py={1}
      pr={1}
      pl={{ xs: 1, lg: 0 }}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Outlet />
    </Grid2>
  )
}

export default AuthLayout
